
import { inject, Injectable } from "@angular/core";
import { SOURCE_TYPE } from "app/modules/manage/workflow/task/workflow-task.constant";
import { STATUS_IN_DATABASE } from "app/shared/common/constants/Status.constant";
import { GRAPHQL_QUERY } from "app/shared/common/utils/graphql/graphql.query.constant";
import { GraphQLService } from "app/shared/common/utils/graphql/graphql.service";
import { from, map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class HrmMetadataGraphQlService {

  #graphQl: GraphQLService = inject(GraphQLService);

  queryEmployeeByEmail(email: string) {
    const where = { email: { _eq: email } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWhere.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        where
      })
    )
  }

  getLocalitiesByWhere(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryPltmLocalityWithCountryTypeWhere.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        where
      })
    )
  }

  queryRecruitSource() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_source_category: { code: { _eq: SOURCE_TYPE.SOURCE } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtmSourceTypeWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => {
        return data?.data?.map((item: any) => {
          delete item.__typename;
          return {
            ...item
          }
        })
      })
    );
  }

  getAllSourceTypes() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_source_category: { code: { _eq: SOURCE_TYPE.SOURCE_TYPE } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtmSourceTypeWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => {
        return data?.data?.map((item: any) => {
          delete item.__typename;
          return {
            ...item
          }
        })
      })
    );
  }

  getAttachmentTypes(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryHrtmAttachmentTypeWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getSkills(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatmSkillWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getJobTracks(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        where
      }));
  }

  getCareerPaths(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatmCareerPathWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getHrmOffice(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryHrtbOfficeWithLocalityWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getJobs(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        where
      }));
  }

  getJobTitles(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatmTitleWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getReferralPayment(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryRstmReferralPaymentWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getGenders(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryTatmGenderWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  getNationality(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryHrtmNationalityWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }
}